/** The size of the scrollbar track in pixels. */
const TRACK_SIZE = 10;
/**
 * The min size of the scroll bar. The scroll bars are typically sized based on the ratio of
 * clientHeight to scrollHeight, but this could result in super tiny scroll bars.
 */
const MIN_SIZE = 24;

export { MIN_SIZE, TRACK_SIZE };
//# sourceMappingURL=scroll-container.constants.js.map
